import { datadogRum } from "@datadog/browser-rum";

export type TApiDatadogConfig = {
    applicationId: string;
    clientToken: string;
    // Free-form environment label used as the Datadog `env` tag.
    environment: string;
    // Whether RUM should be initialised (third-party tools enabled).
    enabled: boolean;
    // Odin API base URL whose requests should carry tracing headers.
    apiBaseUrl: string;
};

export type TApiDatadog = ReturnType<typeof createApiDatadog>;

export const createApiDatadog = ({
    applicationId,
    clientToken,
    environment,
    enabled,
    apiBaseUrl,
}: TApiDatadogConfig) => ({
    setUser: (params: {
        id: string;
        companyId: number;
        companyName: string;
        email: string;
    }) => {
        return datadogRum.setUser(params);
    },
    initRum: () => {
        if (!enabled) {
            console.debug(
                "Skipping Datadog init: third-party tools are disabled.",
            );
            return;
        }

        datadogRum.init({
            applicationId,
            clientToken,
            site: "datadoghq.eu",
            service: "odin",
            env: environment,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            traceSampleRate: 100,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: "mask",
            allowedTracingUrls: [`${apiBaseUrl}/`],
        });

        datadogRum.startSessionReplayRecording();
    },
});
